/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Shipping_Settings_DescriptionInputs */

const en_user_shipping_settings_description = /** @type {(inputs: User_Shipping_Settings_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage carrier blocklists and default accessorials per user`)
};

const es_user_shipping_settings_description = /** @type {(inputs: User_Shipping_Settings_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administra listas de bloqueo y cargos adicionales por usuario`)
};

/**
* | output |
* | --- |
* | "Manage carrier blocklists and default accessorials per user" |
*
* @param {User_Shipping_Settings_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const user_shipping_settings_description = /** @type {((inputs?: User_Shipping_Settings_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Shipping_Settings_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_user_shipping_settings_description(inputs)
	return es_user_shipping_settings_description(inputs)
});